(function () {
  // Lazy‐load videos within a container (defaults to document)
  function initLazyVideoLoading(container = document) {
    const videos = container.querySelectorAll(
      "video.lazy-video:not(.initialized)"
    );
    if (!videos.length) return;

    // IntersectionObserver approach
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const vid = entry.target;

            // Data→src swap
            if (vid.dataset.src) vid.src = vid.dataset.src;
            vid.querySelectorAll("source").forEach((s) => {
              if (s.dataset.src) s.src = s.dataset.src;
            });

            vid.load();
            vid.addEventListener(
              "canplay",
              () => {
                vid.classList.add("loaded");
                vid.play().catch(() => {});
              },
              { once: true }
            );

            vid.classList.add("initialized");
            obs.unobserve(vid);
          });
        },
        { rootMargin: "200px 0px" }
      );

      videos.forEach((v) => io.observe(v));
    } else {
      // Fallback: load immediately
      videos.forEach((vid) => {
        if (vid.dataset.src) vid.src = vid.dataset.src;
        vid.querySelectorAll("source").forEach((s) => {
          if (s.dataset.src) s.src = s.dataset.src;
        });
        vid.load();
        vid.classList.add("initialized");
      });
    }
  }

  // On normal page load
  document.addEventListener("DOMContentLoaded", () => {
    initLazyVideoLoading();
  });

  // When a section is (re)loaded in the Customizer
  document.addEventListener("shopify:section:load", (event) => {
    initLazyVideoLoading(event.target);
  });

  // When a block inside a section is selected/added
  document.addEventListener("shopify:block:select", (event) => {
    const section = event.target.closest("section");
    if (section) initLazyVideoLoading(section);
  });

  // (Optional) If you ever need to teardown observers on unload:
  // document.addEventListener("shopify:section:unload", (event) => {
  //   // e.g. disconnect any stored IntersectionObservers for that section
  // });
})();
